
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ComplianceContextResource,
} from '../models';
import {
    ComplianceContextResourceFromJSON,
    ComplianceContextResourceToJSON,
} from '../models';

export interface GetContextRequest {
    companyId?: string;
}

/**
 * 
 */
export class ComplianceContextApi extends runtime.BaseAPI {

    /**
          */
    async getContextRaw(requestParameters: GetContextRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ComplianceContextResource>> {
        const queryParameters: any = {};

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ComplianceContextResource>({
            path: `/compliance/api/step`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ComplianceContextResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getContext(requestParameters: GetContextRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ComplianceContextResource> {
        const response = await this.getContextRaw(requestParameters, initOverrides);
        return response._data;
    }

}
